import { render } from "./VNavigation.vue?vue&type=template&id=1106310f&scoped=true"
import script from "./VNavigation.vue?vue&type=script&lang=js"
export * from "./VNavigation.vue?vue&type=script&lang=js"

import "./VNavigation.vue?vue&type=style&index=0&id=1106310f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1106310f"]])

export default __exports__